<div
  class="sidebar-overlay"
  [class.open]="sidebarService.isOpen()"
  (click)="sidebarService.close()"
  (keyup.enter)="sidebarService.close()"
  (keyup.space)="sidebarService.close()"
  tabindex="0"
></div>
<aside class="sidebar" [class.open]="sidebarService.isOpen()">
  <div class="sidebar-header">
    <div class="logo">Go Roaming</div>
    <button class="mobile-close-btn" (click)="sidebarService.close()">
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </button>
  </div>

  <nav class="nav-menu">
    <!-- * Dashboard -->
    @if (esimPermissions()[UserPermission.DASHBOARD]) {
      <a
        routerLink="/dashboard"
        routerLinkActive="active"
        class="nav-item"
        (click)="sidebarService.close()"
      >
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
          />
        </svg>
        Dashboard
      </a>
    }
    <!-- * Buy Data Bundles -->
    @if (esimPermissions()[UserPermission.BUY_DATA_BUNDLES]) {
      <a
        routerLink="/buy-data-bundles"
        routerLinkActive="active"
        class="nav-item"
        (click)="sidebarService.close()"
      >
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
          />
        </svg>
        Buy Data Bundles
      </a>
    }
    <!-- * Topup -->
    @if (esimPermissions()[UserPermission.TOPUP]) {
      <a
        routerLink="/topup"
        routerLinkActive="active"
        class="nav-item"
        (click)="sidebarService.close()"
      >
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        Topup
      </a>
    }
    <!-- * Gling Gring Recharge -->
    @if (esimPermissions()[UserPermission.GLING_GRING_RECHARGE]) {
      <a
        routerLink="/gling-gring-recharge"
        routerLinkActive="active"
        class="nav-item"
        (click)="sidebarService.close()"
      >
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
          />
        </svg>
        Gling Gring Recharge
      </a>
    }
    <!-- * Scheduled Subscriptions -->
    @if (esimPermissions()[UserPermission.SCHEDULED_SUBSCRIPTION]) {
      <a
        routerLink="/scheduled-subscriptions"
        routerLinkActive="active"
        class="nav-item"
        (click)="sidebarService.close()"
      >
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        Scheduled Subscriptions
      </a>
    }
    <!-- * History -->
    @if (esimPermissions()[UserPermission.HISTORY]) {
      <a
        routerLink="/history"
        routerLinkActive="active"
        class="nav-item"
        (click)="sidebarService.close()"
      >
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        History
      </a>
    }
    <!-- * Activity Logs (Admin) -->
    @if (isAdmin()) {
      <a
        routerLink="/activity-logs"
        routerLinkActive="active"
        class="nav-item"
        (click)="sidebarService.close()"
      >
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
          />
        </svg>
        Activity Logs
      </a>
    }
    <!-- * Reseller -->
    @if (isAdmin()) {
      @if (esimPermissions()[UserPermission.RESELLER]) {
        <a
          routerLink="/reseller"
          routerLinkActive="active"
          class="nav-item"
          (click)="sidebarService.close()"
        >
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
            />
          </svg>
          Reseller
        </a>
      }
    }
    <!-- * Thai eSIMs -->
    @if (esimPermissions()[UserPermission.THAI_ESIM]) {
      <a
        routerLink="/thai-esims"
        routerLinkActive="active"
        class="nav-item"
        (click)="sidebarService.close()"
      >
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
          />
        </svg>
        Thai eSIMs
      </a>
    }
    <!-- * Package -->
    @if (esimPermissions()[UserPermission.PACKAGE]) {
      <a
        routerLink="/package"
        routerLinkActive="active"
        class="nav-item"
        (click)="sidebarService.close()"
      >
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
          />
        </svg>
        Package
      </a>
    }
    <!-- * Settings -->
    @if (esimPermissions()[UserPermission.SETTINGS]) {
      <a
        routerLink="/settings"
        routerLinkActive="active"
        class="nav-item"
        (click)="sidebarService.close()"
      >
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
          />
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          />
        </svg>
        Settings
      </a>
    }
  </nav>

  <button class="logout-btn" (click)="logout()">
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="20" height="20">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
      />
    </svg>
    Logout
  </button>
</aside>
